import { environment } from '../environments'
import { getLaunchDarklyFlag } from '../services/feature-flags'
import { LaunchDarklyVariations } from '../services/feature-flags/models'

export const getApiBaseUrl = () =>
  getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_USE_GOTO_BASE_URL)
    ? environment().gotoApiBaseUrl
    : environment().jiveApiBaseUrl

export const getJiveApiBaseUrl = () => environment().jiveApiBaseUrl
